import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border border-gray-200 rounded-lg p-4 py-2 mb-4" }
const _hoisted_2 = { class: "grid grid-cols-1 sm:grid-cols-6 gap-4 sm:gap-6 items-center" }
const _hoisted_3 = { class: "flex items-start gap-4 col-span-1" }
const _hoisted_4 = { class: "flex flex-col text-sm text-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary text-md mb-1 font-bold" }, "Data do plantão", -1)
const _hoisted_6 = { class: "text-textPrimary" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-12 self-center border-l border-gray-200 hidden sm:block" }, null, -1)
const _hoisted_8 = { class: "flex flex-col text-sm text-start col-span-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary font-bold text-md mb-1" }, "Status", -1)
const _hoisted_10 = { class: "flex flex-col text-sm text-start col-span-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary font-bold text-md mb-1" }, "Médico", -1)
const _hoisted_12 = {
  key: 0,
  class: "text-textPrimary"
}
const _hoisted_13 = { class: "flex flex-col text-sm text-start col-span-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary font-bold text-md mb-1 truncate block max-w-full" }, "Escala", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "text-textPrimary truncate block max-w-full" }
const _hoisted_17 = { class: "flex flex-col text-sm text-start col-span-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary font-bold text-md mb-1" }, "Prejuízo previsto", -1)
const _hoisted_19 = { class: "text-red-600" }
const _hoisted_20 = { class: "col-span-1 flex items-end justify-start sm:justify-end w-full" }

import { computed } from 'vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import {
  Doctor,
  ExceptionStatusEnum
} from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'
import StatusBadge from '@/components/designSystem/Badges/StatusBadge.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditoriumExceptionalitiesCard',
  props: {
  date: {
    type: String,
    default: ''
  },
  status: {
    type: String as () => ExceptionStatusEnum,
    required: true,
    validator: (val: ExceptionStatusEnum) => Object.values(ExceptionStatusEnum).includes(val)
  },
  doctor: {
    type: Object as () => Doctor | null,
    default: null
  },
  scale: {
    type: String,
    default: ''
  },
  unit: {
    type: String,
    default: ''
  },
  prejudice: {
    type: String,
    required: true
  },
  exceptionId: {
    type: [Number],
    required: true
  }
},
  emits: ["details"],
  setup(__props) {

const props = __props;





const formattedDate = computed(() => {
  if (props.date) {
    try {
      return format(new Date(props.date), 'dd/MM/yyyy', { locale: ptBR })
    } catch (e) {
      console.error('Error formatting date:', e)
      return props.date
    }
  }
  return 'Data não informada'
})

const formattedPrejudice = computed(() => {
  if (props.prejudice) {
    const numericValue = parseFloat(props.prejudice)
    if (!isNaN(numericValue)) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(numericValue)
    }
  }
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(0)
})

const doctorName = computed(() => {
  if (props.doctor && props.doctor.name) {
    return getFirstAndSecondName(props.doctor.name)
  }
  return 'Médico não informado'
})

const doctorCrm = computed(() => {
  if (props.doctor && props.doctor.crm && props.doctor.crm.number && props.doctor.crm.uf) {
    return `${props.doctor.crm.number}-${props.doctor.crm.uf}`
  }
  return ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, [
            _createElementVNode("strong", _hoisted_6, "#" + _toDisplayString(__props.exceptionId), 1),
            _createTextVNode(" · " + _toDisplayString(formattedDate.value), 1)
          ])
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(StatusBadge, { status: __props.status }, null, 8, ["status"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(doctorName.value) + " ", 1),
          (doctorCrm.value)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_12, _toDisplayString(doctorCrm.value), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(__props.scale || 'Não informada') + " ", 1),
          _hoisted_15,
          _createElementVNode("small", _hoisted_16, _toDisplayString(__props.unit || 'Não informada'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("span", _hoisted_19, _toDisplayString(formattedPrejudice.value), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(OutlinedButton, {
          text: "Ver detalhes",
          width: "100%",
          height: "32px",
          class: "sm:!w-[160px]",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('details', props.exceptionId)))
        })
      ])
    ])
  ]))
}
}

})